import { render, staticRenderFns } from "./use-order-list.vue?vue&type=template&id=dc1cbc64&scoped=true&"
import script from "./use-order-list.vue?vue&type=script&lang=js&"
export * from "./use-order-list.vue?vue&type=script&lang=js&"
import style0 from "./use-order-list.vue?vue&type=style&index=0&id=dc1cbc64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1cbc64",
  null
  
)

export default component.exports